import React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";
import { connect } from "react-redux";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import { fetchCharge } from "../../actions/charge";
import { Status } from "../../model/Charge";
import DialogLayout from "../DialogLayout";
import PaymentForm from "../../components/payment/PaymentForm";
import PaymentResult from "../../components/payment/result/PaymentResult";

export class PaymentPage extends React.Component {
  constructor(props) {
    super(props);
    this.getAttValueFromTheme = this.getAttValueFromTheme.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    const { dispatch } = this.props;
    const { params } = match;
    dispatch(fetchCharge(params.id));
  }

  getAttValueFromTheme(currentValue, firstAttribute, secondAttribute) {
    const { charge } = this.props;
    const { theme } = charge;
    return theme &&
      theme.palette &&
      theme.palette[firstAttribute] &&
      theme.palette[firstAttribute][secondAttribute]
      ? theme.palette[firstAttribute][secondAttribute]
      : currentValue;
  }

  render() {
    const { error, isLoading, charge, match } = this.props;
    if (error) {
      return <span>{error}</span>;
    }

    const theme = createMuiTheme({
      typography: {
        fontSize: 16
      },
      palette: {
        primary: {
          light: `${this.getAttValueFromTheme("#29337A", "primary", "light")}`,
          main: `${this.getAttValueFromTheme("#20285f", "primary", "main")}`,
          dark: `${this.getAttValueFromTheme("#171C43", "primary", "dark")}`
        },
        secondary: {
          main: `${this.getAttValueFromTheme("#3775ba", "secondary", "main")}`
        },
        error: {
          main: `${this.getAttValueFromTheme("#db504a", "error", "main")}`
        },
        background: {
          default: `${this.getAttValueFromTheme(
            "#ecebe4",
            "background",
            "default"
          )}`,
          paper: `${this.getAttValueFromTheme("#fff", "background", "paper")}`
        },
        text: {
          primary: `${this.getAttValueFromTheme(
            "rgba(0, 0, 0, 0.87)",
            "text",
            "primary"
          )}`,
          secondary: `${this.getAttValueFromTheme(
            "rgba(0, 0, 0, 0.54)",
            "text",
            "secondary"
          )}`
        }
      }
    });

    let componentToDisplay;
    switch (charge.status) {
      case Status.PAID:
      case Status.DROPPED:
      case Status.DOUBLE_SPEND:
      case Status.LATE_SPEND:
      case Status.REFUNDED:
      case Status.REFUNDED_PARTIALLY:
        componentToDisplay = <PaymentResult charge={charge} />;
        break;
      case Status.DUE:
        componentToDisplay = <PaymentForm charge={charge} match={match} />;
        break;
      default:
        componentToDisplay = <span>Error: charge state is unknown</span>;
        break;
    }

    return (
      <MuiThemeProvider theme={theme}>
        <DialogLayout>
          {isLoading ? <LinearProgress /> : componentToDisplay}
        </DialogLayout>
      </MuiThemeProvider>
    );
  }
}

PaymentPage.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  charge: PropTypes.shape({
    status: PropTypes.string,
    theme: PropTypes.shape()
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  }).isRequired,
  dispatch: PropTypes.func.isRequired
};

PaymentPage.defaultProps = {
  isLoading: true,
  error: undefined,
  charge: {}
};

function mapStateToProps({ chargeReducer }) {
  return chargeReducer;
}

export default connect(mapStateToProps)(PaymentPage);
